import { Navigation } from './NavigationService';
import { Routes } from '../constants/RouterConstants';

export default {
  gotoHome() {
    const route = { pathname: Routes.HOME_PAGE };
    Navigation.push(route);
  },
  gotoOnboardLanguageSelection() {
    const route = { pathname: Routes.LANGUAGE_SELECTION };
    Navigation.push(route);
  },
  gotoOnboardNameInput() {
    const route = { pathname: Routes.ENTER_NAME };
    Navigation.push(route);
  },
  gotoOnboardMobileInput() {
    const route = { pathname: Routes.ENTER_PHONE_NUMBER };
    Navigation.push(route);
  },
  gotoOnboardGenderInput() {
    const route = {
      pathname: Routes.SELECT_GENDER,
    };
    Navigation.push(route);
  },
  gotoOnboardOTPInput() {
    const route = {
      pathname: Routes.ENTER_OTP,
    };
    Navigation.push(route);
  },
  gotoOnboardSelfie() {
    const route = {
      pathname: Routes.SELECT_PROFILE_PICTURE,
    };
    Navigation.push(route);
  },
  gotoCitySelection() {
    const route = {
      pathname: Routes.SELECT_CITY,
    };
    Navigation.push(route);
  },
  gotoAreaSelection() {
    const route = {
      pathname: Routes.SELECT_CURRENT_LOCATION,
    };
    Navigation.push(route);
  },
  gotoQualification() {
    const route = {
      pathname: Routes.SELECT_QUALIFICATION,
    };
    Navigation.push(route);
  },
  gotoWorkExperience() {
    const route = {
      pathname: Routes.WORK_EXPERIENCE,
    };
    Navigation.push(route);
  },
  gotoAgeEntry() {
    const route = {
      pathname: Routes.WHATS_YOUR_AGE,
    };
    Navigation.push(route);
  },
  gotoHomeAddress() {
    const route = {
      pathname: Routes.SELECT_HOME_LOCATION,
    };
    Navigation.push(route);
  },
  gotoMarriageEntry() {
    const route = {
      pathname: Routes.ARE_YOU_MARRIED,
    };
    Navigation.push(route);
  },
  gotoWorkType() {
    const route = {
      pathname: Routes.JOINING_DURATION,
    };
    Navigation.push(route);
  },
  gotoJoiningDuration() {
    const route = {
      pathname: Routes.JOINING_DURATION,
    };
    Navigation.push(route);
  },
  gotoJobChoice() {
    const route = {
      pathname: Routes.MULTIPLE_JOBS,
    };
    Navigation.push(route);
  },
  gotoMultipleSkills() {
    const route = {
      pathname: Routes.MULTIPLE_SKILLS,
    };
    Navigation.push(route);
  },
  gotoBootStrap() {
    const route = {
      pathname: Routes.BOOTSTRAP,
    };
    Navigation.push(route);
  },

  gotoJobInfo({ search }) {
    const route = {
      pathname: Routes.JD,
      search,
    };
    Navigation.push(route);
  },
  gotoJobPreference() {
    const route = {
      pathname: Routes.SELECT_JOB_PREFERENCE,
    };
    Navigation.push(route);
  },
  gotoConnectMitras() {
    const route = {
      pathname: Routes.CONNECT_MITRAS,
    };
    Navigation.push(route);
  },

  gotoApplyJob() {
    const route = {
      pathname: Routes.APPLY_JOB,
    };
    Navigation.push(route);
  },

  gotoApplyJobBike() {
    const route = {
      pathname: Routes.APPLY_JOB_BIKE,
    };
    Navigation.push(route);
  },

  gotoBikeNotAvailable() {
    const route = {
      pathname: Routes.BIKE_NOT_AVAILABLE,
    };
    Navigation.push(route);
  },

  gotoDLNotAvailable() {
    const route = {
      pathname: Routes.DL_NOT_AVAILABLE,
    };
    Navigation.push(route);
  },

  gotoApplyJobDL() {
    const route = {
      pathname: Routes.APPLY_JOB_DL,
    };
    Navigation.push(route);
  },

  gotoApplicationSuccess() {
    const route = {
      pathname: Routes.APPLICATION_SUCCESS,
    };
    Navigation.push(route);
  },
  gotoProfile() {
    const route = {
      pathname: Routes.PROFILE,
    };
    Navigation.push(route);
  },
  gotoMitraProfile({ search }) {
    const route = {
      pathname: Routes.MITRA_PROFILE,
      search,
    };
    Navigation.push(route);
  },
  gotoEditDocument() {
    const route = {
      pathname: Routes.EDIT_DOCUMENT_SAFE,
    };
    Navigation.push(route);
  },
  gotoImagePreview({ staticContext }) {
    const route = {
      pathname: Routes.IMAGE_UPLOAD,
      staticContext,
    };
    Navigation.push(route);
  },
  gotoApplyJobDoc({ search }) {
    const route = {
      pathname: Routes.APPLY_JOB_DOC,
      search,
    };
    Navigation.push(route);
  },
  gotoSalarySelection() {
    const route = {
      pathname: Routes.EXPECTED_SALARY,
    };
    Navigation.push(route);
  },
  gotoUserDetailsEntry({ search }) {
    const route = {
      pathname: Routes.USER_DETAILS,
      search,
    };
    Navigation.push(route);
  },
  gotoMyJobDetails({ search, jobDetails }) {
    const route = {
      pathname: Routes.MY_JOB_STATUS_DETAILS,
      search,
      jobDetails,
    };
    Navigation.push(route);
  },

  gotoMyNotAppliedJobs({ search }) {
    const route = {
      pathname: Routes.MY_JOB_LISTING_For_REJECTED_CANDIDATES,
      search,
    };
    Navigation.push(route);
  },
  gotoMyPrayerWelcome({ search }) {
    const route = {
      pathname: Routes.WELCOME_PRAYER,
      search,
    };
    Navigation.push(route);
  },
  gotoMyJobStatus({ search }) {
    const route = {
      pathname: Routes.My_JOBS_STATUS,
      search,
    };
    Navigation.push(route);
  },
  gotoMyKnowledgeCentre({ search }) {
    const route = {
      pathname: Routes.KNOWLEDGE_CENTRE,
      search,
    };
    Navigation.push(route);
  },
  gotoCaptcha({ search }) {
    const route = {
      pathname: Routes.CAPTCHA,
      search,
    };
    Navigation.push(route);
  },
  gotoMySavingsAmount({ search,amount }) {
    const route = {
      pathname: Routes.SAVINGS_AMOUNT,
      search,
      amount,
    };
    Navigation.push(route);
  },
  gotoMySavings({ search,amount }) {
    const route = {
      pathname: Routes.SELECT_SAVINGS,
      search,
      amount,
    };
    Navigation.push(route);
  },
  gotoMitraTelecaller({ }) {
    const route = {
      pathname: Routes.MITRA_TELECALLER,
    };
    Navigation.push(route);
  },
};
